// The "just watch it" screen: the steps an idea goes through, with where it is now.
// Used under Generate All and on the Review & Publish screen. Display only.
const LOOK = {
  done:    { icon: '✓', color: '#16a34a', bg: '#dcfce7', weight: 500 },
  active:  { icon: '●', color: '#2563eb', bg: '#dbeafe', weight: 700 },
  waiting: { icon: '✋', color: '#b45309', bg: '#fef3c7', weight: 700 },
  failed:  { icon: '✕', color: '#b91c1c', bg: '#fee2e2', weight: 700 },
  pending: { icon: '',       color: '#94a3b8', bg: '#f1f5f9', weight: 400 },
};

const SAYS = { active: 'working', waiting: 'needs you', failed: 'stopped' };

export default function WorkflowMonitor({ steps = [], compact = false }) {
  if (!steps.length) return null;
  return (
    <ol aria-label="Workflow progress" style={{ listStyle: 'none', margin: 0, padding: 0, display: 'grid', gap: compact ? 4 : 6 }}>
      <style>{'@keyframes shpulse{0%,100%{opacity:1}50%{opacity:.35}}'}</style>
      {steps.map((s) => {
        const look = LOOK[s.state] || LOOK.pending;
        return (
          <li key={s.id} data-state={s.state} aria-current={s.state === 'active' ? 'step' : undefined}
            style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: compact ? 12 : 13, color: look.color, fontWeight: look.weight }}>
            <span aria-hidden="true" style={{ width: 22, height: 22, borderRadius: '50%', background: look.bg, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, flexShrink: 0, animation: s.state === 'active' ? 'shpulse 1.4s ease-in-out infinite' : 'none' }}>{look.icon}</span>
            <span style={{ flex: 1 }}>{s.label}</span>
            {s.detail && <span style={{ fontWeight: 500, opacity: 0.85 }}>{s.detail}</span>}
            {SAYS[s.state] && <span style={{ fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.04em' }}>{SAYS[s.state]}</span>}
          </li>
        );
      })}
    </ol>
  );
}
